import React from 'react';
import './LanguageSwitcher.css';

interface LanguageSwitcherProps {
  selectedLanguage: 'en' | 'el';
  onLanguageChange: (language: 'en' | 'el') => void;
  variant?: 'default' | 'compact' | 'header';
  className?: string;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  selectedLanguage,
  onLanguageChange,
  variant = 'default',
  className = ''
}) => {
  return (
    <div className={`language-selector ${variant} ${className}`}>
      <div className="language-buttons">
        <button 
          className={`language-btn ${selectedLanguage === 'el' ? 'active' : ''}`}
          onClick={() => onLanguageChange('el')}
          type="button"
        >
          🇬🇷 Ελληνικά
        </button>
        <button 
          className={`language-btn ${selectedLanguage === 'en' ? 'active' : ''}`}
          onClick={() => onLanguageChange('en')}
          type="button"
        >
          🇺🇸 English
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;